import React from 'react';
import styles from '../stateroomdetails.module.scss';
import { AlwaysIncludedProps } from '@msc-b2c/interfaces/types';
import { Icon, Text } from '@msc-b2c/shared-components';

const AlwaysIncluded: React.FC<AlwaysIncludedProps> = ({
  alwaysIncludedTitle,
  alwaysIncludedElements,
}) => {
  return (
    <div className={styles.alwaysIncludedContainer}>
      <Text
        text={alwaysIncludedTitle}
        styleOption={styles.alwaysIncludedTitle}
      />
      <div className={styles.alwaysIncludedContent}>
        {alwaysIncludedElements.map((element, index) => {
          return (
            <div
              key={`${element.elementLabel}-${element.elementIcon}`}
              className={styles.alwaysIncludedElement}
            >
              <Icon icon={element.elementIcon} />
              <Text
                text={element.elementLabel}
                styleOption={styles.alwaysIncludedValue}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AlwaysIncluded;
